import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=3621b917&scoped=true&"
import script from "./UserRow.vue?vue&type=script&lang=js&"
export * from "./UserRow.vue?vue&type=script&lang=js&"
import style0 from "./UserRow.vue?vue&type=style&index=0&id=3621b917&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3621b917",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VEditDialog,VIcon,VTextField})
